import { backendUrl } from '@shared/constants/urls/appUrls';
import { fetchWithAuth } from '@shared/utils/auth';

//------------------------------------------------------------------------------
//             Отправить запрос на получение обновлений на странице
//------------------------------------------------------------------------------
export const checkUpdatedData = async (unix) => {
  const url = `${backendUrl}/api/alpha/check-update/?datetime=${unix}`;
  const options = {
    method: 'GET',
    headers: {'Content-Type': 'application/json'},
  };
  try {
    const response = await fetchWithAuth(url, options);
    // 429 — серверный троттл (3/мин), штатная ситуация: цикл пропускаем, не ошибка
    if (response.status === 429) {
      console.warn('[AutoUpdate] check-update: превышен лимит запросов, цикл пропущен');
      return null;
    }
    if (!response.ok) {
      throw new Error(`Сетевая ошибка при получении иформации об обновлениях на странице: HTTP error! Status: ${response.status}`);
    }
    return await response.json();
  } catch (error) {
    console.error('Программная ошибка получения информации об обновлениях на странице:', error);
    throw error;
  }
};
//xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
